import values from '../../../res/values';
import color from '../../../res/color';

export default {
    main: {
        height: '100vh',
        width: '100vw',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: color.themeColor,
    },
    contentFrame: {
        height: '90%',
        display: 'flex',
        position: 'relative',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },
    howtoText: {
        color: color.whiteFontColor,
        fontSize: values.fontMidium,
        outline: 'none',
        position: 'absolute',
        backgroundColor: color.transparent,
        paddingLeft:'5%',
        paddingRight:'5%',
        top: '2%',
        right: '2%'
    },
    iconsFrame: {
        height: '20%',
        width: '40%',
        position: 'relative',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-around',
        alignSelf: 'center',
        alignItems: 'center',
    },
    icon: {
        height: 'auto',
        width: '30%',
        position: 'relative',
        display: 'flex',
        userSelect: "none",
    },
    title: {
        position: 'relative',
        width: '100%',
        height:'6%',
        alignSelf: 'center',
        alignItems: 'center',
        textAlign: 'center',
        color: color.whiteFontColor,
        fontSize: values.fontLarge,
        fontWeight: 'bold',
        userSelect: "none",
    },
    subTitle: {
        position: 'relative',
        height:'4%',
        width: '100%',
        alignSelf: 'center',
        alignItems: 'center',
        textAlign: 'center',
        color: color.whiteFontColor,
        fontSize: values.fontMidium,
        userSelect: "none",
        marginTop:-10
    },
    settingFrame: {
        height:'20%',
        width: '100%',
        padding: '1%',
        display: 'flex',
        flexDirection: 'row',
        position: 'relative',
        alignSelf: 'center',
        alignItems: 'center',
        justifyContent: 'center',
    },
    settingItemFrame: {
        width: '20%',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        alignSelf: 'center',
        alignItems: 'center',
        marginRight: '2%',
        marginLeft: '2%',
        border: '1px solid' + color.borderBlack,
        borderRadius: 10,
        paddingBottom: '2%',
        paddingRight: '2%',
        paddingLeft: '2%',
        backgroundColor: color.veryLightThemeColor,
    },
    mettingSettingTitle: {
        position: 'relative',
        width: '100%',
        alignSelf: 'center',
        alignItems: 'center',
        textAlign: 'center',
        fontWeight: 'bold',
        color: color.blackFontColor,
        fontSize: values.fontMediumLarge,
        userSelect: "none",
    },
    radioGroup: {
        height: 'auto',
        width: '100%',
        position: 'relative',
        display: 'flex',
        flexDirection: 'row',
        color: color.blackFontColor,
        alignSelf: 'center',
        alignItems: 'center',
        textAlign: 'center',
        justifyContent: 'space-around',
        fontSize: values.fontMidium,
    },
    radioText: {
        marginRight: '2%',
        marginLeft: '1%',
        fontWeight: 'bold',
    },
    commentFrame: {
        height:'10%',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        alignSelf: 'center',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '1%'
    },
    comment: {
        height: '5%',
        position: 'relative',
        width: '100%',
        alignSelf: 'center',
        alignItems: 'center',
        textAlign: 'center',
        color: color.whiteFontColor,
        fontSize: values.fontSmall,
        userSelect: "none",
    },
    buttonsFrame: {
        height: '10%',
        width:'40%',
        position: 'relative',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-around',
        alignSelf: 'center',
        alignItems: 'center',
        marginTop: '3%',
    },
    buttonPositive: {
        height:'100%',
        width:'40%',
        alignSelf: 'center',
        alignItems: 'center',
        backgroundColor: color.buttonCream,
        border: '1px solid' + color.lightBorderColor,
        borderRadius: 15,
        userSelect: "none",
        cursor: 'pointer',
        marginBottom:'5%',
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        fontSize: values.fontMediumLarge,
        outline: 'none'
    },
    links: {
        width: '100%',
        position: 'absolute',
        justifyContent: 'space-around',
        display: 'flex',
        alignSelf: 'center',
        alignItems: 'center',
        flexDirection: 'row',
        backgroundColor: color.themeColorTrans,
        bottom: 0,
    },
    link: {
        alignSelf: 'center',
        alignItems: 'center',
        cursor: 'pointer',
        userSelect: "none",
        color: color.blackFontColor,
        textDecoration: "none",
        fontSize: values.fontSmall,
    },
    poweredByEmpath: {
        width: '100%',
        textAlign: 'center',
        alignSelf: 'center',
        alignItems: 'center',
        color: color.whiteFontColor,
        fontSize: values.fontSmall,
        position: 'relative',
        userSelect: "none",
    },

}